<template lang="pug">
div(v-if="showIcon" :class="iconClass").dropdown-account-crypto-system-icon {{ title }}
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Account } from '../../../models/finance/account';
import { UsdtNetworkTitles, UsdtNetworkType } from '@/models/finance/crypto';

@Component({
  name: 'dropdown-account-crypto-system-icon',
})
export default class DropdownAccountCryptoSystemIcon extends Vue {
  @Prop({ required: true })
  account: Account

  get a(): Account {
    if ('hasCryptoSystem' in this.account) return this.account;

    return Object.assign(new Account(), this.account);
  }

  get showIcon() {
    return this.a.hasCryptoSystem;
  }

  get iconClass() {
    const system = this.a.cryptoSystem ? this.a.cryptoSystem.toLowerCase() : null;
    if (!system) return {};

    return {
      [`dropdown-account-crypto-system-icon__${system}`]: true,
    };
  }

  get networkTitles() {
    return UsdtNetworkTitles;
  }

  get title() {
    if (!this.account.cryptoSystem) return null;

    const system = this.account.cryptoSystem;
    return system in this.networkTitles ? this.networkTitles[system] : null;
  }
}
</script>

<style scoped lang="less">
@import "../../../assets/capitalist-config";

.dropdown-account-crypto-system-icon {
  display: inline-block;
  font-size: 90%;
  background: #777777;
  border-radius: 3px;
  padding: 3px 5px;
  color: #fff;
  line-height: 1em;

  &.dropdown-account-crypto-system-icon__ {
    &ethereum {
      background: @colorCryptoUsdtErc20;
    }
    &tron {
      background: @colorCryptoUsdtTrc20;
    }
  }
}
</style>
